/* eslint-disable react/no-unescaped-entities */
import React from "react";
import styled from "styled-components";
import AnimatedCursor from "react-animated-cursor";

const Footer = () => {
  return (
    <NewPortfolioFooter>
      <AnimatedCursor color="255, 255, 255" />

      <ContactSection>
        <p>chat with me maybe</p>
        <EmailLink href="mailto:hi@tiffchan.com">
          <h1>hi@tiffchan.com</h1>
        </EmailLink>
      </ContactSection>

      <LinksSection>
        <a
          href="https://www.linkedin.com/in/nottiffchan/"
          target="_blank"
          rel="noreferrer"
        >
          linkedin
        </a>
        <a href="https://x.com/tortillatiff" target="_blank" rel="noreferrer">
          x(twitter)
        </a>
        <a
          href="https://nottiffchan-v3-7owhelb2y-coconut-bra.vercel.app/"
          target="_blank"
          rel="noreferrer"
        >
          my student portfolio (2022)
        </a>
      </LinksSection>

      <FlowerImage
        src="/animatedFlowers.mov"
        width={280}
        height={178}
        alt="Decorative flowers"
        autoPlay
        muted
        loop
        playsInline
      />
    </NewPortfolioFooter>
  );
};

export default Footer;

const NewPortfolioFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5rem 0 0 0;
  gap: 3rem;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #005ae0;

  p,
  a {
    font-family: "Geist Mono" !important;
    color: white;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }

  a:hover {
    opacity: 0.7;
  }

  h1 {
    color: white;
    font-family: "Instrument Serif";
    font-weight: 400;
    margin-block-start: 1rem;
    margin-block-end: 0;
  }

  @media (max-width: 640px) {
    h1 {
      font-size: 40px;
    }
  }
`;

const ContactSection = styled.div`
  text-align: center;

  p {
    margin: 0;
    margin-bottom: 0.5rem;
  }
`;

const EmailLink = styled.a`
  text-decoration: none;

  &:hover h1 {
    opacity: 0.8;
    transition: opacity 0.2s ease;
  }
`;

const LinksSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    gap: 1.5rem;
    flex-direction: column;
    text-align: center;
  }
`;

const FlowerImage = styled.video`
  margin: auto;

  @media (max-width: 640px) {
    width: 240px;
    height: auto;
  }
`;
